export const CYPRESS_ENV = window.Cypress !== undefined

export const NO_ACCESS_SERVICE_IDENTIFICATOR = '*'
export const NO_ACCESS_SERVICE = {
  availableActions: [],
  id: NO_ACCESS_SERVICE_IDENTIFICATOR,
  name: NO_ACCESS_SERVICE_IDENTIFICATOR,
}

export const REGULAR_EXPRESSIONS = {
  EMAIL: /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i,
  PASSWORD: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/,
  ID: /(\d|[a-z]){13}/,
  DATE: /\d{4}-\d{2}-\d{2}/,
  AMOUNT: /\d{1,}/,
}

export const BRAND_NAMES = {
  other: 'Other',
  OTHERS: 'Others',
  amex: 'American Express',
  aura: 'Aura',
  bankcard: 'Bank card',
  cup: 'China UnionPay',
  dankort: 'Dankort',
  diners: 'Diners Club',
  discover: 'Discover',
  elo: 'Elo',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  insta_payment: '',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  inter_payment: '',
  jcb: 'JCB',
  laser: '',
  maestro: 'Maestro',
  mastercard: 'Mastercard',
  solo: 'Solo',
  switch: 'Switch',
  uatp: 'UATP',
  visa: 'Visa',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  visa_electron: 'Visa Electron',
  unknown: 'Unknown',
}

export const REASON_CODES = {
  OTHERS: 'Others',
}

export const NOTIFICATION_TYPES = {
  DEFAULT: 'default',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
}

export enum HEADER_ACTION_TYPES {
  DEFAULT = 'default',
  DANGER = 'danger',
  ACCEPT = 'accept',
}
